module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/video",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _c('span', [_vm._v("Video Pembelajaran")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175308c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vd_pembelajaran/components/Navigation.vue
// module id = 2255
// module chunks = 1